import { render, staticRenderFns } from "./updateThumbnailImage.vue?vue&type=template&id=2df0c652&scoped=true&"
import script from "./updateThumbnailImage.vue?vue&type=script&lang=js&"
export * from "./updateThumbnailImage.vue?vue&type=script&lang=js&"
import style0 from "./updateThumbnailImage.vue?vue&type=style&index=0&id=2df0c652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0c652",
  null
  
)

component.options.__file = "updateThumbnailImage.vue"
export default component.exports